import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import styled from '@emotion/styled';
import Button from '../Button';
import breakpoints from '../Theme/breakpoints';

const LinkButton = styled(Button)`
&& {
  margin: 12px 12px 0;
  min-width: fit-content;
}
`;

const SpecialLinksButton = React.forwardRef<HTMLButtonElement, {
  children: string;
}>(
  ({ ...properties }, reference) => (
    <LinkButton
      ref={reference}
      role="link"
      {...properties}
    />
  ),
);

const SpecialLinksWrapper = styled.div`
  width: 100%;
  margin: 0 0 12px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  flex-wrap: wrap;

  @media (min-width: ${breakpoints.sm}px) {
    flex-direction: row;
  }
`;

const specialLinksPropertyTypes = {
  links: PropTypes.node.isRequired,
};

type SpecialLinksPropertyTypes = InferProps<typeof specialLinksPropertyTypes>;

const SpecialLinks = ({ links }: SpecialLinksPropertyTypes) => (
  <SpecialLinksWrapper>
    { links }
  </SpecialLinksWrapper>
);

SpecialLinks.propTypes = specialLinksPropertyTypes;

export { SpecialLinksButton };

export default SpecialLinks;
